
import React from 'react';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import { withStyles } from '@material-ui/core/styles';

import '../Components.css';

import { styles } from 'Utilities/Constants/Shirt_Constants'



class ShirtForm extends React.Component {

    handleChange(field, value) {
        let shirtValids = this.props.valids.shirt;
        switch (field) {
            case "type":
                if (parseInt(value) === 1 || parseInt(value) === 2) {
                    this.props.setType(value);
                    shirtValids.type = true;
                } else if (this.props.shirtType === "") {
                    shirtValids.type = false;
                }
                break;
            case "size":
                const shirtSizes = this.props.concessionData[0].tshirt_sizes.map(size => size.size_id);
                if (shirtSizes.includes(value)) {
                    this.props.setSize(value);
                    shirtValids.size = true;
                } else if (this.props.shirtSize === "") {
                    shirtValids.size = false;
                }
                break;
            case "colour":
                const shirtColours = this.props.concessionData[0].tshirt_colours.map(colour => colour.colour_id);
                if (shirtColours.includes(value)) {
                    this.props.setColour(value);
                    shirtValids.colour = true;
                } else if (this.props.shirtColour === "") {
                    shirtValids.colour = false;
                }
                break;
            case "quantity":
                if (value > 0) {
                    this.props.setQuantity(Number(value));
                    shirtValids.quantity = true;
                } else if (parseInt(this.props.shirtQuanity) === 0 || parseInt(value) === 0) {
                    shirtValids.quantity = false;
                }
                break;
            default:
                return
        }

        //update valids
        let newValids = this.props.valids;
        newValids.shirt = shirtValids;
        this.props.updateValids(newValids);
    }

    processText = (type, value) => {
        //take numbers of string and return. if no numbers, then return 0 to the handleChange function
        let regex = /\d+/g;
        let numbers = (value !== undefined && value !== null) ? value.match(regex) : null;
        let final_num = (numbers !== null) ? numbers.reduce((number, totalNum) => number + totalNum, "") : 0;
        this.handleChange(type, final_num);
    }

    render() {

        return (
            <React.Fragment>
                <Typography variant="h6" gutterBottom>
                    <div className="section-header">Shirt Information</div>
                </Typography>
                <Grid container spacing={24}>
                    <Grid item xs={12} sm={6}>
                        <TextField
                            id="type"
                            select
                            label="Fit"
                            fullWidth
                            name="type"
                            className="inputField"
                            value={this.props.shirtType}
                            onChange={e => {
                                this.handleChange("type", e.target.value)
                            }}

                            error={(this.props.valids.shirt.type === null || !this.props.valids.shirt.type) && this.props.nextAttempted}   //leaving for testing purposes
                            helperText={((this.props.valids.shirt.type === null || !this.props.valids.shirt.type) && this.props.nextAttempted) ? "Please select a shirt type" : ""}
                        >
                            {this.props.concessionData[0].tshirt_genders.map((option, index) => (
                                <MenuItem key={index} value={option.gender_id}>
                                    {option.gender_name}
                                </MenuItem>
                            ))}
                        </TextField>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <TextField
                            id="size"
                            select
                            label="Sizes"
                            fullWidth
                            name="numPlayers"
                            // disabled={this.state.existingTeamPlayers >= 3 ? true : false}
                            onChange={e => {
                                this.handleChange("size", e.target.value)
                            }}
                            value={this.props.shirtSize}
                            error={(this.props.valids.shirt.size === null || !this.props.valids.shirt.size) && this.props.nextAttempted}
                            helperText={((this.props.valids.shirt.size === null || !this.props.valids.shirt.size) && this.props.nextAttempted) ? "Please select a shirt size" : ""}
                        >
                            {this.props.concessionData[0].tshirt_sizes.map((option, index) => (
                                <MenuItem key={index} value={option.size_id}>
                                    {option.size_name}
                                </MenuItem>
                            ))}
                        </TextField>
                    </Grid>

                    <Grid item xs={12} sm={6}>
                        <TextField
                            id="colour"
                            select
                            label="Colours"
                            fullWidth
                            name="colours"
                            // disabled={this.state.existingTeamPlayers >= 3 ? true : false}
                            onChange={e => {
                                this.handleChange("colour", e.target.value)
                            }}
                            value={this.props.shirtColour}
                            error={(this.props.valids.shirt.colour === null || !this.props.valids.shirt.colour) && this.props.nextAttempted}
                            helperText={((this.props.valids.shirt.colour === null || !this.props.valids.shirt.colour) && this.props.nextAttempted) ? "Please select a shirt colour" : ""}
                        >
                            {this.props.concessionData[0].tshirt_colours.map((option, index) => (
                                <MenuItem key={index} value={option.colour_id}>
                                    {option.colour_name}
                                </MenuItem>
                            ))}
                        </TextField>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <TextField
                            required
                            id="quantity"
                            name="quantity"
                            label="Quantity"
                            fullWidth
                            // value={this.props.shirtQuanity}
                            placeholder={this.props.shirtQuantity}
                            // onBlur={this.checkTeamName}
                            onChange={e => {
                                this.processText("quantity", e.target.value);
                            }}
                            defaultValue={(this.props.shirtQuantity) ? this.props.shirtQuantity : ""}
                            error={(this.props.valids.shirt.quantity === null || !this.props.valids.shirt.quantity) && this.props.nextAttempted}
                            helperText={((this.props.valids.shirt.quantity === null || !this.props.valids.shirt.quantity) && this.props.nextAttempted) ? "Please enter a valid quantity" : ""}
                        />
                    </Grid>

                </Grid>

            </React.Fragment>
        )
    }
}

// ShirtForm.propTypes = {
//     classes: PropTypes.object.isRequired,
// };

export default withStyles(styles)(ShirtForm);